import { render } from "./CookiesCompanyCard.vue?vue&type=template&id=73c4e22e&ts=true"
import script from "./CookiesCompanyCard.vue?vue&type=script&lang=ts"
export * from "./CookiesCompanyCard.vue?vue&type=script&lang=ts"

import "./CookiesCompanyCard.vue?vue&type=style&index=0&id=73c4e22e&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__